const initialState = {
  lat: -8.409518,
  lng: 115.188919,
  id: null,
  detailTempatUsaha: {
    idwajibpajak: '',
    pajak_kategori: '',
    npwpd: '',
    nop: '',
    nama: '',
    alamat: '',
    telp: '',
    email: '',
    keterangan: '',
    wilayah: '',
  },
  detailWajibPajak: {
    npwp: '',
    nama: '',
    alamat: '',
    telp: '',
    email: '',
  },
};
/**
 * @function mapReducer
 * @summary
 * To set global state of lat lng user and marker props
 * @param state
 * @param action
 * @returns {{lng: number, lat: *}|{lng: number, lat: number} | {marker props : object | detail tempat usaha}
 */
export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    case 'HANDLE_CHANGE_LOCATION':
      return {
        ...state,
        lat: action.payload.lat,
        lng: action.payload.lng,
      };
    case 'HANDLE_CHANGE_MARKER_ID':
      return {
        ...state,
        id: action.payload.id,
      };
    case 'HANDLE_CHANGE_TEMPAT_USAHA':
      return {
        ...state,
        detailTempatUsaha: action.payload.detailTempatUsaha,
      };
    case 'HANDLE_CHANGE_WAJIB_PAJAK':
      return {
        ...state,
        detailWajibPajak: action.payload.detailWajibPajak,
      };
    default:
      return state;
  }
}
